module.exports = __webpack_public_path__ + "img/Steve Mc Millan.7aa9a5ec.jpg";